import { __assign, __rest } from "tslib";
import React from 'react';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import CommentIcon from '@wix/da-ds/pkg/Icons/24x24/Comment';
import Stat from './Stat';
import useDeviationStats from './useDeviationStats';
var CommentStat = function (_a) {
    var deviation = _a.deviation, onlyNumbers = _a.onlyNumbers, _b = _a.withUserList, withUserList = _b === void 0 ? true : _b, className = _a.className, baseProps = __rest(_a, ["deviation", "onlyNumbers", "withUserList", "className"]);
    var _c = useDeviationStats(deviation), comments = _c.comments, isCommentable = _c.isCommentable;
    return !isCommentable ? null : (React.createElement(Stat, __assign({ className: className, deviation: deviation, statCount: comments, icon: CommentIcon, onlyNumbers: onlyNumbers, userListType: withUserList ? 'comment' : undefined, statNameLocaleKey: "deviation.stats.comments", dataHook: BiDataHook.DEVIATION_COMMENTS_COUNTER, biData: BiData({
            evid: 2,
            click_info: 'comments',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue,
        }) }, baseProps)));
};
CommentStat.displayName = 'CommentStat';
export default CommentStat;
//# sourceMappingURL=CommentStat.js.map